import { render } from "./TransactionStatus.vue?vue&type=template&id=417e31e2&scoped=true"
import script from "./TransactionStatus.vue?vue&type=script&lang=js"
export * from "./TransactionStatus.vue?vue&type=script&lang=js"

import "./TransactionStatus.vue?vue&type=style&index=0&id=417e31e2&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417e31e2"]])

export default __exports__